import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import toast from "react-hot-toast";
import { LayoutDashboard } from "lucide-react";
import Menu from "./Menu";
import { store } from "../../store/store";
import { logout } from "../../store/actions/authActions";

const Sidebar = () => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const name = useAppSelector(
    (state) => state.user?.userProfile?.firstName ?? null
  );
  const currentRole = useAppSelector(
    (state) => state.user.userProfile?.currentRole?.replaceAll("_", " ") ?? null
  );
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    localStorage.clear();
    store.dispatch(logout());
    toast.success("You have been logged out successfully.", {
      position: "top-right",
    });
  };

  return (
    <>
      <div className="flex h-full grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-4 pb-4">
        <nav className="flex flex-1 flex-col">
          <div className="h-20 relative text-left flex items-center justify-center">
            <button
              className="flex w-full justify-between items-center rounded-xl bg-primary-lightest p-2 text-left"
              type="button"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => setShowMenu((menuState) => !menuState)}
            >
              <span className="sr-only">Open user menu</span>
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 40 40"
                  fill="none"
                >
                  <circle
                    cx="19.9997"
                    cy="19.9997"
                    r="19.4118"
                    fill="#AABBBC"
                  />
                  <circle
                    cx="20"
                    cy="20"
                    r="19.8529"
                    stroke="#8766CD"
                    strokeWidth="0.294118"
                  />
                  <path
                    d="M15.2942 29.6791C14.8531 31.2967 9.706 33.7968 6.4707 33.7968C13.9517 41.7382 27.2255 40.8026 33.7657 33.7968C29.2883 33.4851 25.2787 31.5137 24.3401 29.6791V26.7379C25.2417 25.6238 25.6903 24.9607 26.1408 23.4829C26.2291 23.0092 26.2262 22.6712 26.1408 22.0076C26.5285 22.1286 26.7258 22.1019 27.0303 21.7619C27.2175 20.7755 27.2543 20.265 27.2255 19.409L28.0831 17.9137C28.3747 15.6145 28.2573 14.8475 27.8483 14.8475C27.5078 14.9007 27.2504 15.5063 26.8706 15.7148C28.2899 12.4662 28.2899 7.95606 26.4716 6.78123L25.04 7.0539C24.2148 6.17221 23.6831 5.81876 22.586 5.44058L22.8018 5.99733L20.8525 5.23235C18.1734 3.77811 14.6197 5.60966 13.0281 7.36497C12.6988 8.97781 12.2803 9.82693 11.3606 11.3228C11.7674 13.3065 12.0821 14.3187 12.7121 16.045L12.0517 15.0875C11.7566 14.8848 11.296 14.8492 11.296 15.0875C11.1115 16.1943 11.1301 16.7377 11.296 17.6421L12.2433 19.409C12.1105 20.325 12.2838 20.8402 12.4077 21.7619C12.8654 22.3043 13.2667 22.0773 13.6766 21.885C13.4746 22.3314 13.3427 22.5483 13.3825 23.0615C13.3825 23.5026 14.3599 25.4008 15.2942 26.7379V29.6791Z"
                    fill="#6C797A"
                  />
                </svg>
                <div className="flex flex-col">
                  <span
                    className="text-sm font-semibold text-primary-dark capitalize"
                    aria-hidden="true"
                  >
                    {name}
                  </span>
                  <span
                    className="text-sm font-normal capitalize"
                    aria-hidden="true"
                  >
                    {currentRole}
                  </span>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                aria-hidden="true"
                className="ml-2 h-5 w-5 text-gray-400"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </button>
            {/* when click on the button */}
            <div
              className={`absolute right-0 top-16 mt-1 z-10 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transform ${
                showMenu ? "opacity-100 scale-100" : "opacity-0 scale-0"
              } transition-all`}
              role="menu"
              tabIndex={0}
            >
              <div className="py-1" role="none">
                <div
                  className="sidebar-menu-link cursor-pointer"
                  onClick={() => {
                    handleLogout();
                  }}
                >
                  Logout
                </div>
              </div>
            </div>
          </div>
          <hr />

          {/* menu */}
          <Menu />
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
